







































































import { AxiosResponse, AxiosError } from 'axios';
import { ToastMessage } from '@/plugins/toast/models/message';
import { PageTitle } from '@/common/components';
import services from '@/services';
import lang from '../../common/lang/de';
import { User, TermsOfUse, ErrorStatesOptions } from '../../models';
import { TermsOfUseVm } from './viewModel';
import mapper from './mappers';
import { RulesOperatorHelper } from '../../common/utils/RulesOperatorHelper';
import { Viewer } from '../../common/components';

const { UserService } = services;

export default {
  components: {
    PageTitle,
    viewer: Viewer,
  },
  data() {
    return ({
      osaId: '' as string,
      addressInfo: '' as string,
      text: '' as string,
      disabled: false,
      termsOfUse: {} as TermsOfUseVm,
      userParams: {} as User,
    });
  },
  created() {
    this.userParams.customer = this.$store.getters['user/getDebtorNumber'];
    if (RulesOperatorHelper.validateEmail(this.userParams.customer)) {
      this.userParams.customer = localStorage.getItem('callCenterSelectedCustomerNumber') as string;
    }
    this.getTermsOfUse();
  },
  methods: {
    getTermsOfUse() {
      this.$loader.show();
      UserService.getTermsOfUse(this.userParams).then((result: AxiosResponse<TermsOfUse>) => {
        this.termsOfUse = mapper.mapTermsOfUseToTermsOfUseVm(result.data);
        setTimeout(() => {
          this.$loader.hide();
        }, 500);
      }).catch((err: AxiosError) => {
        if ((err.response !== undefined) && (err.response.status === 401 || err.response.status === 500)) {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.NotAuthorized);
          this.$router.push({ name: 'Index' });
        } else {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.UnexpectedError);
        }
      });
    },
    newSupportRequest() {
      if (this.disabled) {
        if (RulesOperatorHelper.validateEmail(this.userParams.customer)) {
          this.userParams.customer = localStorage.getItem('callCenterSelectedCustomerNumber') as string;
        }

        this.$router.push({
          name: 'NewSupportRequest',
          params: {
            id: this.userParams.customer as string,
          },
        });
      }
    },
    toBack() {
      this.$router.go(-1);
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    },
  },
};
